/**
 * DisplayZoneContext — the viewer's resolved display timezone (Epic #532).
 *
 * Deliberately a separate, dependency-free module: AuthContext imports axios
 * and the session dialog, and every presentational leaf that renders a
 * timestamp (DataTable cells, inbox rows, thread messages) would otherwise
 * inherit that whole tree — and every one of their tests would have to mock
 * it. This file imports React only.
 *
 * AuthProvider publishes `resolveDisplayZone({ user })` here (profile zone,
 * browser fallback). Consumers read it through hooks/useDisplayZone.js; a
 * tree mounted without any provider gets `null` and the hook falls back to
 * the browser zone — the epic's real terminal fallback, never silent UTC.
 */
import { createContext } from 'react';

const DisplayZoneContext = createContext(null);

export default DisplayZoneContext;
